export default __webpack_public_path__ + "static/media/poll_3.ec8686a7.jpg";